'use strict';

function ctrl($scope, Global, $location, settings, $http, usSpinnerService) {
    let model = this;

    $scope.global = Global;
    model.settings = settings;

    $http({method: 'GET', url: api+'/api/stealth/stealth_deploy_config/forcestealth'}).
    success(function (data) {
        $scope.$broadcast('stealthForceChart', data);
        usSpinnerService.stop('spinner-stealth_deploy_config');
    });

    model.save_coordinates = function (node) {
        $http({
            method: 'POST',
            url: api+'/api/stealth/stealth_deploy_config/save_coordinates',
            data: {
                x: node.x,
                y: node.y,
                name: node.name,
                type: node.type
            }
        });
    }
}

ctrl.$inject = ['$scope', 'Global', '$location', 'settings', '$http', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/stealth/stealth_deploy_config.js
 **/